<template>
  <div
    :class="[{ 'rounded-xl bg-positive-50 px-3 py-1': statusOk }, { 'rounded-xl bg-negative-50 px-3 py-1': !statusOk }]"
  >
    <UiText class="text-primary-600 typography-text-xs">{{ text }}</UiText>
  </div>
</template>

<script setup lang="ts">
import type { TagProps } from '~/components/ui/Tag/types';

withDefaults(defineProps<TagProps>(), {
  statusOk: true,
});
</script>
